import { Loader2Icon, UsersIcon } from 'lucide-react';
import { Alert, AlertDescription, AlertTitle } from '@/components/lumen/alert';
import { Button } from '@/components/lumen/button';

export interface ColleagueFilledPanelProps {
  title: string;
  /** Label/value rows, e.g. the colleague's tempat, nama, jabatan. */
  details?: Array<{ label: string; value: string }>;
  continueLabel: string;
  keepLabel: string;
  onContinue: () => void;
  onKeep: () => void;
  busy?: boolean;
}

/**
 * Top-of-step notice that a colleague filled this step's data while the user
 * was in the wizard. "Lanjut" skips the step as done, the other action keeps
 * the step open.
 */
export default function ColleagueFilledPanel({
  title,
  details,
  continueLabel,
  keepLabel,
  onContinue,
  onKeep,
  busy = false,
}: ColleagueFilledPanelProps) {
  return (
    <Alert variant="info" className="mb-4" data-colleague-panel>
      <UsersIcon aria-hidden="true" />
      <AlertTitle className="line-clamp-none">{title}</AlertTitle>
      <AlertDescription className="gap-3">
        {details && details.length > 0 && (
          <dl className="m-0 grid gap-0.5">
            {details.map((row) => (
              <div key={row.label} className="flex items-baseline gap-2">
                <dt className="min-w-37.5 text-fg-muted">{row.label}</dt>
                <dd className="m-0 font-semibold text-fg">{row.value || '-'}</dd>
              </div>
            ))}
          </dl>
        )}
        <div className="flex flex-wrap gap-3">
          <Button size="sm" onClick={onContinue} disabled={busy} aria-busy={busy || undefined}>
            {busy && <Loader2Icon className="animate-spin" aria-hidden="true" />}
            {continueLabel}
          </Button>
          <Button size="sm" variant="outline" onClick={onKeep} disabled={busy}>
            {keepLabel}
          </Button>
        </div>
      </AlertDescription>
    </Alert>
  );
}
